export default __webpack_public_path__ + "static/feigningFear-aef12f56bacb907ce7bf6b1c59ef222d.svg";